import { render, staticRenderFns } from "./qygzs.vue?vue&type=template&id=4d086f61&scoped=true"
import script from "./qygzs.vue?vue&type=script&lang=js"
export * from "./qygzs.vue?vue&type=script&lang=js"
import style0 from "./qygzs.vue?vue&type=style&index=0&id=4d086f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d086f61",
  null
  
)

export default component.exports